import { ModelBase } from '@barthauer/abc/core/data';
import { ExportMode } from '@barthauer/abc/interfaces/core/wizards/wizard-export';
import { ParameterValue } from '@barthauer/abc/queries/parameters/core';

export class GisExportWizardTransferObject {
  exportMode: GisWizardExportMode;
  constructor() {}
}

export class GisWizardExportMode {
  public selectedMode: ExportMode;

  constructor(data: any) {
    Object.assign(this, data);
  }
}

export class GisExportQueryModel extends ModelBase {
  ExteriorPolygon?: number[][];
  Parameters?: ParameterValue[];
  ActiveLayers?: string[];

  constructor() {
    super();
  }
}
